import { useState } from "react";
import { API_BASE_URL } from "../../config/api";
import { Link } from "react-router-dom";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(`${API_BASE_URL}/api/auth/forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (res.ok) {
        setMessage("Reset link sent to your email.");
      } else {
        setMessage(data.message);
      }
    } catch {
      setMessage("Something went wrong");
    }
  };

  return (
    <div className="auth-container">
      {/* LEFT SIDE */}
      <div className="auth-left">
        <h1>Fraud Detect System</h1>
        <p>Secure access for Self-Drive Car Rental Owners</p>
      </div>

      {/* RIGHT SIDE */}
      <div className="auth-right">
        <div className="auth-box">
          <h2>Forgot Password</h2>
          <p className="auth-sub">
            Enter your registered email to receive reset link
          </p>

          <form onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <button type="submit" className="primary-btn">
              Send Reset Link
            </button>
          </form>

          {message && <p className="auth-message">{message}</p>}

          <Link to="/" className="auth-link">
            Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;